import { API_SITE_CORPO } from "../api_endpoint";
import { http  } from '../http';

export const getAllFooter = async ( ) => {  
	try {
		let x=API_SITE_CORPO.FOOTER 
		let { data } = await http.get(x);
		
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const saveFooter = async (footer: any) =>{

	try {
		let endPoint= API_SITE_CORPO.FOOTER 
		let { data } = await http.post(endPoint, footer);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
}

export const importFooter = async (file: File) => {
	try {
		let x=API_SITE_CORPO.FOOTER +"/import"
		let { data } = await http.post(x, file);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}